<template>
    <div>
        <div class="title">
            {{ myObj.word_banner_params.title }}
        </div>
        <div class="list">
            <div v-for="(item, index) in 5" class="item" :style="getItemStyle()" :key="index"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WordBannerView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj,

        }
    },
    methods: {
        getItemStyle() {
            return 'width:' + this.obj.word_banner_params.item_width + "px;" +
                'height:' + this.obj.word_banner_params.item_height + "px;" +
                'border-radius:' + this.obj.word_banner_params.corner_radius + "px"
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    margin-left: 15px;
    line-height: 40px;
}

.list {
    margin-left: 15px;
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;

    .item {
        background-color: #f5f5f5;
        width: 100px;
        height: 40px;
        margin-right: 10px;
        display: inline-block;
    }
}
</style>